import nlp from 'compromise';
import datePlugin from 'compromise-dates';

nlp.plugin({
  // ambiguous words
  words: {
    wed: 'WeekDay',
    weds: 'WeekDay',
    sat: 'WeekDay',
    sun: 'WeekDay',
  },

  // add methods to run after the tagger does
  compute: {
    postProcess: (doc: Doc) => {
      // tag '2/2' as a date (not a fraction)
      doc.match('/[0-9]{1,2}/[0-9]{1,2}/').tag('#Date');

      doc.replace('hr', 'hour', true).tag('Date');
      doc.replace('hrs', 'hours', true).tag('Date');
      doc.replace('sec', 'seconds', true).tag('Date');
      doc.replace('secs', 'seconds', true).tag('Date');
    },
  },

  /** run it on init */
  hooks: ['postProcess'],
});

nlp.plugin(datePlugin);
